import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScheduledDeploymentCalendar from '../components/ScheduledDeploymentCalendar';

const DeploymentCalendar = () => {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="breadcrumb">
        <button onClick={() => navigate('/dashboard')} className="breadcrumb-link">Dashboard</button>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Deployment Calendar</span>
      </nav>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '3px solid #EF4444' }}>
          <div>
            <h2 style={{ color: 'var(--gray-900)', fontSize: '1.5rem', fontWeight: 'bold', margin: '0 0 0.25rem 0' }}>
              📅 Deployment Calendar
            </h2>
            <p style={{ color: 'var(--gray-600)', margin: 0, fontSize: '0.875rem' }}>
              Schedule and manage content deployments across all your channels
            </p>
          </div>
        </div>
        
        <ScheduledDeploymentCalendar />
      </div>
    </div>
  );
};

export default DeploymentCalendar;
